import LandingLayout from "@/layout/landing/LandingLayout.vue";
import AuthLayout from "@/layout/auth/AuthLayout.vue";

export default [
  {
    path: "/voucher/verify",
    component: LandingLayout,
    props: { footer: false },
    meta: { requiresAuth: false },
    children: [
      {
        path: "",
        name: "voucher-verify",
        component: () =>
          import(
            /* webpackChunkName: "payments" */ "@/views/backoffice/Payments/VoucherVerify.vue"
          ),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound-layout",
    component: AuthLayout,
    children: [
      {
        path: "",
        name: "notfound",
        component: () =>
          import(/* webpackChunkName: "system" */ "@/views/system/404View.vue"),
      },
    ],
  },
];
